import { Gift, Lightbulb } from 'lucide-react';
import { Link } from 'react-router';
import './announcement-banner.css';

export function AnnouncementBanner() {
  return <aside className="gfp-announcements" aria-label="GramFather updates">
    <div><Gift size={16} aria-hidden="true"/><span>Earn by sharing GramFather. <Link to="/affiliates">Learn about the affiliate program</Link></span></div>
    <div><Lightbulb size={16} aria-hidden="true"/><span>Help shape GramFather. We’re building the feature requests that fit. <button type="button" onClick={() => window.dispatchEvent(new CustomEvent('gf-help-assistant', { detail: { panel: 'feature' } }))}>Suggest a feature</button></span></div>
  </aside>;
}
